import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiClipboardPulseOutline, mdiMagnifyRemoveOutline } from "@mdi/js";

export default function Page404() {
	const navigate = useNavigate();

	return (
		<Container className="d-flex justify-content-center flex-column p-4 pb-0" style={{ minHeight: "100vh" }}>
			<Row>
				<Col lg={{ span: 6, offset: 3 }}>
					<Card className="p-3 shadow-lg bg-white rounded-3">
						<Card.Body className="text-center">
							<div className="d-flex justify-content-center align-items-center gap-2 mb-5">
								<Icon path={mdiClipboardPulseOutline} style={{ height: 64 }} />
								<div className="d-flex flex-column align-items-center fs-1 lh-1">Monitor</div>
							</div>

							<Card.Title className="text-center mb-2 fs-2">
								<Icon path={mdiMagnifyRemoveOutline} size={4} />
							</Card.Title>
							<Card.Title className="mb-5 fs-4 fw-light">Página não encontrada</Card.Title>

							<div className="d-flex justify-content-center gap-2">
								<Button
									variant="light"
									onClick={() => {
										navigate("/");
									}}
									style={{ width: 160 }}
								>
									Ir para o início
								</Button>
								<Button
									variant="light"
									onClick={() => {
										navigate(-1);
									}}
									style={{ width: 160 }}
								>
									Voltar
								</Button>
							</div>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}
